import { Button, Form, FormControl, FormGroup, FormLabel } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { emptyUsersGroup } from "../interfaces/UsersGroup";
import UserSelector from "../elements/UserSelector";
import { useState } from "react";
import { User } from "../interfaces/User";
import { useTranslation } from "react-i18next";
import { Overlay } from "../elements/Overlay";

export interface UsersGroupAddProps {
    submitCallback: CallableFunction;
    closeCallback: CallableFunction;
}

export default function UsersGroupAdd(props: UsersGroupAddProps) {
    const { t } = useTranslation();
    
    const navigate = useNavigate();

    const userId = localStorage.getItem('userId');

    const [usersSelected, setUsersSelected] = useState<any[]>([]);

    const handleClose = () => {
        props.closeCallback();
    }

    const handleSubmit = (event: any) => {
        event.preventDefault();
        let error = false;
        let error_messages: string[] = [];
        
        if (error) {
            alert(error_messages.join('\n'));
        } else {
            const newUsersGroup = Object.assign({});
            newUsersGroup.name = event.target.name.value;
            newUsersGroup.description = event.target.description.value;
            newUsersGroup.userId = userId;
            newUsersGroup.users = usersSelected.map((u: any) => { 
                return {
                    _id: u.id,
                    email: u.email,
                    firstname: u.firstname,
                    lastname: u.lastname
                }; 
            });
            const requestOptionsPost = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + localStorage.getItem('token')
                },
                body: JSON.stringify(newUsersGroup)
            };
            fetch(import.meta.env.VITE_API_URL + '/v1/users-groups', requestOptionsPost)
                .then(response => {
                    if (response.status !== 200) {
                        navigate('/');
                    }
                    return response.json();
                })
                .then(data => {
                    props.submitCallback(data);                    
                });
        }
    }

    return(
        <Overlay
            title={ t("Add new group") }
            onClose={ handleClose }
            className="usersgroup-add-org-container"
        >
            <div className="usersgroup-form-container">
                <Form onSubmit={ handleSubmit }>
                    <FormGroup className="name" controlId="name">
                        <Form.Label aria-required={ true }>{ t("Name") }</Form.Label>
                        <Form.Control type="name" required={ true } name="name"
                            placeholder={ t("Enter a name") } />
                    </FormGroup>
                    <Form.Group className="field field-description">
                        <FormLabel htmlFor="description">{ t("Description") }</FormLabel>
                        <FormControl as="textarea" name="description" />
                    </Form.Group>
                    <h5>{ t("Users") }</h5>
                    <p>
                        { t("You can add users of your organization or any user in taskGen.") }
                    </p>
                    <UserSelector users={ [] } usersCallback={ setUsersSelected } />
                    <div className="actions">
                        <Button type="submit" variant="primary">{ t("Save") }</Button>
                    </div>
                </Form>
            </div>
        </Overlay>
    );
}